import clsx from 'clsx'
import { STATUS_COLORS } from '@/utils/constants'

interface BadgeProps {
  children: React.ReactNode
  variant?: 'primary' | 'success' | 'warning' | 'danger' | 'gray' | 'info' | 'error'
  status?: string
  className?: string
}

export default function Badge({ children, variant, status, className }: BadgeProps) {
  // Auto-detect variant from status if provided
  let badgeVariant = variant

  if (status && !variant) {
    const color = STATUS_COLORS[status.toLowerCase()]
    switch (color) {
      case 'blue':
        badgeVariant = 'primary'
        break
      case 'green':
        badgeVariant = 'success'
        break
      case 'yellow':
        badgeVariant = 'warning'
        break
      case 'red':
        badgeVariant = 'danger'
        break
      default:
        badgeVariant = 'gray'
    }
  }

  const variantClasses: Record<string, string> = {
    primary: 'badge-primary',
    success: 'badge-success',
    warning: 'badge-warning',
    danger: 'badge-danger',
    gray: 'badge-gray',
    info: 'badge-primary',
    error: 'badge-danger',
  }

  return (
    <span className={clsx('badge', variantClasses[badgeVariant || 'gray'], className)}>
      {children}
    </span>
  )
}
